import { LOCATION_CHANGE } from '../authentication/authentication.module';

export default function vanity(
  state = {
    vanityInitialized: false,
    vanityName: 'default',
  },
  { type }
) {
  switch (type) {
    case LOCATION_CHANGE: {
      if (state.vanityInitialized) {
        return state;
      }
      const van = /van?=?([\w-]+)?/.exec(window.location.search);
      const vanity = /vanity?=?([\w-]+)?/.exec(window.location.search);
      return {
        ...state,
        vanityName:
          (vanity && vanity[1]) || (van && van[1]) || state.vanityName,
      };
    }

    default:
      return state;
  }
}
